import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Storages from "../helper/storages";
import { HiOutlineHome, HiOutlineClipboardList } from 'react-icons/hi'
import History from './history'
import { IoSettingsOutline } from 'react-icons/io5'
import { IoMdClose, IoMdArrowRoundBack } from 'react-icons/io'
import { FaArrowLeft, FaWallet } from 'react-icons/fa'
import { BiMessageSquareDetail } from 'react-icons/bi'
import { CgProfile } from 'react-icons/cg'
import { AiOutlineStar } from 'react-icons/ai'

import { VscSignOut } from 'react-icons/vsc'
import DashboardContext from "../contexts/dashboardContext";
import NavKey from '../reducerKeys/navbarKey.json'
import paths from './../config/paths.json'
import axios from "axios";
import useEndpoints from "../api/useEndpoints";
import ErrorHandler from "../api/errorHandler";
export default function SideBar(props) {
    const navigate = useNavigate();
    var logo = require(`../assets/images/${process.env.REACT_APP_ENV}/avatar.png`)


    var endpoints = useEndpoints();

    var onLogout = () => {
        Storages.removeUserToken()
        navigate(paths.login);
    }
    const dContext = useContext(DashboardContext);
    var onClick = () => {

        dContext.setOpen(false)
        // dContext.navDispatch({ type: NavKey.toggleClick , value:!dContext.navState.isOpen})
    }

    var [balance, setBalance] = useState(Storages.getBalance())

    useEffect(() => {
        getBalance()
    }, [])
    var getBalance = () => {
        axios.get(endpoints.balance,
            {
                headers:
                {
                    'x-auth-token': Storages.getUserToken()
                }
            }).then((res) => {
                console.log(res)
                setBalance(res.data.result.balance)
                Storages.setBalance(res.data.result.balance)
                setTimeout(() => {
                    getBalance()
                }, 30000)
            }).catch((e) => {
                console.log(e)
                ErrorHandler(e)
            })

    }


    return (
        <div className="vh-100 bg-dark" >

            <div className="d-flex ">
                <FaArrowLeft size={30} color="white" className="m-3 me-auto" onClick={onClick} />

            </div>
            <div className="sidebar col-12 d-flex flex-column bg-dark   ">

                <div className="justify-content-center align-items-center d-flex flex-column ">
                    <img className="m-0  mt-2" src={logo} style={{ width: '6rem', height: '6rem' }} />
                    <h3 className="menuName w-100">{Storages.getUserInfo()?.name}</h3>
                </div>

                {/* <Link onClick={onClick} to="/dashboard" className="link" ><HiOutlineHome /> خانه</Link> */}
                <a className="link-no-border bg-success text-warning"><FaWallet className="text-warning" /> اعتبار فعلی : {balance} تومان</a>

                <Link onClick={onClick} to={paths.history} className="link" ><HiOutlineClipboardList /> گزارش سرویس ها</Link>
                <Link onClick={onClick} to={paths.favorite} className="link"><AiOutlineStar /> آدرس های منتخب </Link>
                <Link onClick={onClick} to={paths.message} className="link"><BiMessageSquareDetail /> پیام ها </Link>
                <Link onClick={onClick} to={paths.profile} className="link"><CgProfile /> حساب کابری</Link>

                <Link onClick={onLogout} to={paths.login} className="link mt-auto"><VscSignOut /> خروج از حساب کاربری</Link>
            </div>
        </div>

    )
}